import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import BackButtonComponent from '../../../components/BackButtonComponent/BackButtonComponent';
import ComponentCircleLoader from '../../../components/Loaders/ComponentCircleLoader';
import { PrimaryButton } from '../../../styledComponents/buttons';
import {
  ColoredText,
  CommonFlex,
  CommonGrid,
  CommonText,
  Container,
  ContentHeader,
  InputLabel,
  PageTitle,
} from '../../../styledComponents/common';
import { LabelTextBlock } from '../../Tasks/TaskDetails/taskDetailsStyles';
import {
  InfoContainer,
  InfoSectionContainer,
  OfficeDetailsSingleInfo,
  ZoneButton,
} from '../officesStyles';
import ZoneDetails from './ZoneDetails';

const OfficeDetails = ({
  officeDetails,
  getOfficeDetails,
  getItemSummary,
  history,
  clearOfficeCreatedUpdated,
  isDetailsLoading,
  itemSummary,
}) => {
  const memberships = localStorage.getItem('memberships') || '[]';
  const parsedMemberships =
    localStorage.getItem('user_role') === 'admin'
      ? []
      : JSON.parse(memberships);
  const allowedPublicZones = Array.from(
    new Set(parsedMemberships.map(membership => membership.public_zone)),
  );
  const { t } = useTranslation();
  const location = useLocation();
  const userRole = localStorage.getItem('user_role');
  const queryParams = new URLSearchParams(location.search);
  const officeId = queryParams.get('id');

  const [activeZone, setActiveZone] = useState('Mina');
  const [updatedOfficeDetails, setUpdatedOfficeDetails] = useState([]);

  const handleActiveZoneChange = zone => {
    setActiveZone(zone);
  };

  useEffect(() => {
    if (officeId) {
      getOfficeDetails({ officeId });
    }
  }, [officeId]);

  useEffect(() => {
    setUpdatedOfficeDetails(officeDetails);
  }, [officeDetails]);
  useEffect(() => {
    if (
      allowedPublicZones?.length > 0 &&
      !allowedPublicZones.includes(activeZone)
    ) {
      setActiveZone(allowedPublicZones[0]);
    }
  }, [allowedPublicZones, activeZone]);

  useEffect(() => {
    if (itemSummary && officeDetails) {
      const publicZoneId = officeDetails.public_zone_detail.find(
        zone => zone.public_zone_name === activeZone,
      )?.id;
      if (publicZoneId && !itemSummary[publicZoneId]) {
        getItemSummary({ officeId, zoneId: publicZoneId });
      }
    }
  }, [itemSummary, officeDetails, activeZone]);

  useEffect(() => {
    if (itemSummary && officeDetails) {
      const updatedDetails = { ...officeDetails };
      updatedDetails.public_zone_detail = officeDetails.public_zone_detail
        .filter(zone => zone.public_zone)
        .map(zone => {
          const itemSummaryData = itemSummary[zone.id];
          return {
            ...zone,
            itemSummary: itemSummaryData,
          };
        });
      setUpdatedOfficeDetails(updatedDetails);
    }
  }, [itemSummary, officeDetails]);

  return (
    <div className="content">
      <ContentHeader>
        <BackButtonComponent
          onClick={() => history.push('/user/offices')}
          subTitle={t('back_to_all_offices')}
        />
      </ContentHeader>
      <CommonFlex justifyContent="space-between">
        <PageTitle>{t('office_details')}</PageTitle>
        {!['qa_controller', 'employee', 'supervisor'].includes(userRole) && (
          <PrimaryButton
            onClick={() => history.push('/user/update-office?id=' + officeId)}
          >
            {t('edit_office')}
          </PrimaryButton>
        )}
      </CommonFlex>
      <Container padding="30px" gap="40px">
        {isDetailsLoading ? (
          <ComponentCircleLoader />
        ) : (
          <>
            <InfoSectionContainer>
              <InfoContainer>
                <OfficeDetailsSingleInfo>
                  <InputLabel>{t('office_name')}:</InputLabel>
                  <CommonText fontSize="12px">{officeDetails?.name}</CommonText>
                </OfficeDetailsSingleInfo>
              </InfoContainer>
              <InfoContainer>
                <OfficeDetailsSingleInfo>
                  <InputLabel>{t('nationality')}:</InputLabel>
                  <CommonText>{officeDetails?.nationality || '-'}</CommonText>
                </OfficeDetailsSingleInfo>
              </InfoContainer>
              <InfoContainer>
                <OfficeDetailsSingleInfo>
                  <InputLabel>{t('number_of_pilgrims')}:</InputLabel>
                  <CommonText>
                    {officeDetails?.pilgrims_number || '-'}
                  </CommonText>
                </OfficeDetailsSingleInfo>
              </InfoContainer>{' '}
            </InfoSectionContainer>
            <CommonFlex
              style={{
                zIndex: 2,
                backgroundColor: '#F1F1F1',
                width: 'max-content',
                padding: '10px',
                borderRadius: '6px',
              }}
            >
              {(allowedPublicZones?.length > 0
                ? allowedPublicZones
                : ['Mina', 'Arafat', 'Muzdalifah']
              ).map(zone => (
                <ZoneButton
                  key={zone}
                  active={activeZone === zone}
                  onClick={() => handleActiveZoneChange(zone)}
                >
                  {zone}
                </ZoneButton>
              ))}
            </CommonFlex>
            {updatedOfficeDetails?.public_zone_detail
              ?.filter(
                zone => !activeZone || zone.public_zone_name === activeZone,
              )
              .map(zone => (
                <ZoneDetails key={zone.id} zone={zone} />
              ))}
          </>
        )}
      </Container>
    </div>
  );
};

export default OfficeDetails;
